module.exports = __webpack_public_path__ + "img/logo2.89309bbd.png";